<script setup lang="ts"></script>

<template>
    <!--    <div>-->
    <!--        <FormKit type="submit">{{ $t("crud:button.save") }}</FormKit>-->
    <!--    </div>-->
    <button type="submit" class="btn btn-primary">{{ $t("crud:button.save") }}</button>
</template>
